<header class="long-header">
  <div
    class="flex-container"
    fxLayout="column"
    fxLayout.gt-sm="row"
  >
    <div
      class="img-wrapper"
      style="background-image: url('/assets/images/about-us/header_background.jpg')"
      fxFlex="100%"
      fxFlex.gt-sm="50%">
    </div>
    <div
      fxFlex="100%"
      fxFlex.gt-sm="50%"
      class="header-content-wrapper"
    >
      <div
        fxLayout="column"
        fxLayoutAlign="center center"
        fxLayoutAlign.gt-sm="center start"
      >
        <h2>
          {{ webPage.title }}
        </h2>
        <div [innerHTML]="webPage.html" class="header-content"></div>
      </div>
    </div>
  </div>
</header>

<!--<section
  class="center container-fluid our-team"
  *ngIf="agents.length"
>
  <h2>
    Echipa
    <span class="after-title">
      {{ agencyService.agency.name }}
    </span>
  </h2>
  <div
    fxLayout="row wrap"
    fxLayoutAlign="center"
    class="container our-team-list"
  >
    <div
      fxLayout="column"
      fxLayoutAlign="space-between center"
      class="our-team-item"
      *ngFor="let agent of agents"
    >
      <div
        class="center"
        (click)="openAgentModal(agent)"
        class="our-team-content"
      >
        <div class="img-wrapper">
          <div
            class="my-image"
            [ngStyle]="{'background-image': 'url(' + agent.avatar.url + ')'}">
          </div>
        </div>
        <h2>
          {{ agent.first_name }}
          <span>
            {{ agent.last_name }}
          </span>
        </h2>
        <label>
          {{ agent.job }}
        </label>
      </div>
    </div>
  </div>
</section>-->

<section class="container-fluid info">
  <div>
    Dezvoltăm proiecte imobiliare pentru tine și familia ta!
  </div>
</section>

<app-testimonials></app-testimonials>



// WEBPACK FOOTER //
// ./src/app/about-us/about-us.component.html